import { render, staticRenderFns } from "./SortableHeader.vue?vue&type=template&id=f0149eac&scoped=true"
import script from "./SortableHeader.vue?vue&type=script&lang=js"
export * from "./SortableHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0149eac",
  null
  
)

export default component.exports